import { apiProximidadObtenerTutoresEnCamino } from "../API";
import { IApiResult } from "../models/Entities";
import { IProximidadTutorItem, MProximidadTutorItem } from "../models/MProximidadItem";
import { RequestData } from "../utils/RequestData";

export function _SvProximidadObtenerTutoresEnCamino(idGrupo?: number, idEscuela?: number): Promise<MProximidadTutorItem[]> {
    return new Promise<MProximidadTutorItem[]>((resolve) => {
        if (!idGrupo) {
            resolve([]);
            return;
        }

        const params = {
            IdGrupo: idGrupo,
            IdEscuela: idEscuela,
        }

        new RequestData<IApiResult<IProximidadTutorItem[]>>(apiProximidadObtenerTutoresEnCamino)
            .Params(params)
            .Completion((response, error) => {
                if (error) {
                    resolve([]);
                    return;
                }
                resolve(
                    (response?.Datos || [])
                        .map(item => new MProximidadTutorItem(item, idGrupo))
                        .filter(item => item.getTieneAlumnosAsignadosEnClase())
                );
            }).Get();
    });
}